import { getMajorVersion } from 'helpers';
import { TaxaOverTime } from 'services/insights/useTaxaOverTime';

type VersionInfo = {
  hasMultipleVersions: boolean;
  currentKitHasOlderVersion: boolean;
};

export default function useGetAnalysisVersionInfo(
  data: TaxaOverTime,
  currentKitId?: string,
): VersionInfo {
  if (!data?.length || !currentKitId)
    return { hasMultipleVersions: false, currentKitHasOlderVersion: false };

  const uniqueVersions = new Set(
    data.map(point => getMajorVersion(point?.version ?? '')),
  );

  const hasMultipleVersions = uniqueVersions.size > 1;

  if (!hasMultipleVersions)
    return { hasMultipleVersions: false, currentKitHasOlderVersion: false };

  const currentKitDataPoint = data.find(point => point.kit_id === currentKitId);
  const currentKitVersion = getMajorVersion(currentKitDataPoint?.version ?? '');

  const allVersions = Array.from(uniqueVersions).filter(v => v > 0);
  const latestVersion = Math.max(...allVersions);

  const currentKitHasOlderVersion =
    currentKitVersion > 0 && currentKitVersion < latestVersion;

  return { hasMultipleVersions, currentKitHasOlderVersion };
}
